// src/components/home/RetreatsSection.jsx
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

// Images
import cardiologyImg from '../../assets/A-image7.png';
import neuroImg from '../../assets/A-image8.png';
import inflammatoryImg from '../../assets/A-image9.png';
import lifestyleImg from '../../assets/A-image10.png';
import ncdImg from '../../assets/A-image7.png';
import oncologyImg from '../../assets/A-image8.png';
import painImg from '../../assets/A-image9.png';

const RetreatsSection = () => {
  const scrollContainerRef = useRef(null);

  const retreats = [
{
  category: "Ayurvedic Cardiology",
  title: "Preventive Cardiology & Heart Rejuvenation Program",
  doctor: "Dr. Rajesh Vaidya",
  duration: "21 Days",
  image: cardiologyImg, // create or use A-image14.png
  slug: "cardiology-preventive"
},   
{
  category: "Ayurvedic Neurology",
  title: "Brain & Nerve Rejuvenation Program",
  doctor: "Dr. Priya Menon",
  duration: "21 Days",
  image: neuroImg,
  slug: "neurology-retreat"
},
{
    category: "Inflammatory & Autoimmune Disorders",
    title: "Heart-Brain Autoimmunity Retreat",
    doctor: "Dr. Kavya Iyer & Expert Panel",
    duration: "21 Days",
    image: inflammatoryImg,  // or whatever image you assign
    slug: "inflammatory-Autoimmune"
  },
{
  category: "Lifestyle Disorders",
  title: "Potentials of Ayurveda in Lifestyle Disorders",
  doctor: "National Faculty Panel",
  duration: "21 Days",
  image: lifestyleImg,
  slug: "lifestyle-disorders"
},
{
  category: "Non-Communicable Diseases",
  title: "Integrative Management of NCDs",
  doctor: "National Expert Panel",
  duration: "21 Days",
  image: ncdImg,
  slug: "non-communicable-diseases"
},
{
  category: "Oncology Supportive Care",
  title: "Ayurvedic Perspectives in Oncology Supportive Care",
  doctor: "Rasayana & Integrative Oncology Panel",
  duration: "21 Days",
  image: oncologyImg,
  slug: "oncology-supportive-care"
},
{
  category: "Pain Management",
  title: "Evidence-Based Ayurvedic Pain Management",
  doctor: "National Pain Faculty Panel",
  duration: "21 Days",
  image: painImg,
  slug: "pain-management"
}
  ];

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -340, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 340, behavior: 'smooth' });
  };

  return (
    <section id="retreats" className="bg-[#E8E1D4] py-16 sm:py-20 md:py-24 px-4 sm:px-6 lg:px-8 font-playfair text-center">
      {/* Header */}
      <div className="inline-block border border-[#0B2A2C] text-[#0B2A2C] px-6 py-2 rounded-full text-xl mb-6">
        Retreats
      </div>
      <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-[#0B2A2C]">
        Our Ayurvedic Treatments
      </h2>
      <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-12 leading-relaxed">
        Experience personalized healing therapies designed to rejuvenate your body and balance your inner energy.
      </p>

      {/* Scrollable Area */}
      <div className="relative max-w-7xl mx-auto">
        {/* Prev/Next Buttons */}
        <button
          onClick={scrollLeft}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-20 bg-white hover:bg-gray-50 shadow-2xl rounded-full p-4 transition-all -ml-6 hidden lg:block"
          aria-label="Previous"
        >
          <svg className="w-6 h-6 text-[#0B2A2C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button
          onClick={scrollRight}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-20 bg-white hover:bg-gray-50 shadow-2xl rounded-full p-4 transition-all -mr-6 hidden lg:block"
          aria-label="Next"
        >
          <svg className="w-6 h-6 text-[#0B2A2C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Cards Container */}
        <div
          ref={scrollContainerRef}
          className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth px-4 lg:px-0 pb-4"
          style={{ scrollbarWidth: 'none' }}
        >
          {retreats.map((item) => (
            <div
              key={item.title}
              className="group relative flex-shrink-0 w-80 h-[520px] rounded-3xl overflow-hidden cursor-pointer bg-white "
            >
              {/* Main Card - Always Visible */}
              <div className="absolute inset-0 flex flex-col">
                {/* Image at Top */}
                <div className="h-64 flex items-center justify-center pt-8">
                  <div className="w-52 h-52 rounded-3xl overflow-hidden shadow-2xl border-8 border-white">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 p-8 pt-6 flex flex-col justify-between">
                  <div>
                    <span className="text-sm font-semibold text-gray-600">{item.category}</span>
                    <h3 className="text-xl font-bold text-[#0B2A2C] mt-2 mb-6 leading-tight">
                      {item.title}
                    </h3>

                    {/* Doctor + Duration in One Row */}
                    <div className="flex items-center justify-between text-sm">
                      <div className="flex items-center gap-3">
                        <div className="text-left">
                          <p className="text-xs text-gray-500 uppercase tracking-wider">Therapist</p>
                          <p className="font-semibold text-[#0B2A2C] text-xs">{item.doctor}</p>
                        </div>
                      </div>

                      <div className="flex items-center gap-2 text-[#0B2A2C]">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="font-medium text-sm">{item.duration}</span>
                      </div>
                    </div>
                  </div>

                  {/* View More - Centered */}
                  <div className="mt-8 text-center">
  <Link
    to={`/retreats/${item.slug}`}
    className=" text-[#0B2A2C] font-semibold text-sm border-b-2 border-[#0B2A2C] pb-1 hover:border-transparent hover:bg-[#0B2A2C] hover:text-white transition-all duration-300 inline-block px-6 py-2 rounded-full"
  >
    View More →
  </Link>
</div>
                </div>
              </div>

              {/* Hover Sliding Image Layer */}
              <div className="absolute inset-0 rounded-3xl overflow-hidden transition-transform duration-700 ease-out group-hover:-translate-y-full">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

                <div className="absolute bottom-0 left-0 right-0 p-8 text-left">
                  <span className="text-sm font-medium text-white/90">{item.category}</span>
                  <h3 className="text-3xl font-bold text-white mt-2 drop-shadow-2xl">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Button */}
      <div className="mt-16">
        <button className="solox-btn bg-[#0B2A2C] text-white hover:text-[#0B2A2C] border-2 border-[#0B2A2C] px-10 py-4 rounded-full text-lg font-medium hover:bg-[#0A2426] transition">
          <span>View All Treatments</span>
        </button>
      </div>
    </section>
  );
};

export default RetreatsSection;